import React, { useState } from "react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Pin } from "lucide-react";
import { toast } from "sonner";

/** Pin any indication label to an area (manual beats AI beats rules). */
export function AreaOverrideForm({ areas, disabled, onChanged }) {
    const [open, setOpen] = useState(false);
    const [label, setLabel] = useState("");
    const [area, setArea] = useState("");
    const [busy, setBusy] = useState(false);
    const submit = async (e) => {
        e.preventDefault();
        if (!label.trim() || !area) return;
        setBusy(true);
        try {
            const r = await api.put(`/v1/ripeness/areas/overrides/${encodeURIComponent(label.trim())}`, { area, reason: "manual override from QA Radar" });
            toast.success(`${r.data.label} → ${r.data.area} · ${r.data.tracks_reprojected ?? 0} tracks re-projected${r.data.forwarded ? ` on the hub (${r.data.processed_on})` : ""}`);
            setLabel(""); setArea("");
            onChanged?.();
        } catch (e2) {
            toast.error(`Override failed: ${formatApiErrorDetail(e2)}`);
        } finally {
            setBusy(false);
        }
    };
    return (
        <div data-testid="area-override-form">
            <button onClick={() => setOpen(!open)} className="text-[11px] text-slate-400 hover:text-slate-200 inline-flex items-center gap-1" data-testid="area-override-toggle">
                <Pin className="w-3 h-3" /> {open ? "Hide" : "Pin an indication to an area"}
            </button>
            {open ? (
                <form onSubmit={submit} className="mt-1 space-y-1">
                    <input value={label} onChange={(e) => setLabel(e.target.value)} placeholder="Indication label exactly as shown (e.g. Nodular Goiter)" disabled={disabled || busy}
                        className="w-full rounded border border-slate-700 bg-slate-900 px-2 py-1 text-[11px] text-slate-200 placeholder:text-slate-600 disabled:opacity-50"
                        data-testid="area-override-label-input" />
                    <div className="flex gap-1">
                        <select value={area} onChange={(e) => setArea(e.target.value)} disabled={disabled || busy}
                            className="flex-1 min-w-0 rounded border border-slate-700 bg-slate-900 px-1.5 py-1 text-[11px] text-slate-200 disabled:opacity-50" data-testid="area-override-area-select">
                            <option value="">Area…</option>
                            {areas.map((a) => <option key={a} value={a}>{a}</option>)}
                        </select>
                        <button type="submit" disabled={disabled || busy || !label.trim() || !area}
                            className="rounded bg-emerald-500/80 hover:bg-emerald-500 px-2 py-1 text-white disabled:opacity-40 disabled:cursor-not-allowed" data-testid="area-override-submit">
                            Pin
                        </button>
                    </div>
                </form>
            ) : null}
        </div>
    );
}
